import { render, staticRenderFns } from "./LinkageField.vue?vue&type=template&id=474d2512&scoped=true&"
import script from "./LinkageField.vue?vue&type=script&lang=js&"
export * from "./LinkageField.vue?vue&type=script&lang=js&"
import style0 from "./LinkageField.vue?vue&type=style&index=0&id=474d2512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474d2512",
  null
  
)

export default component.exports